var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    style: {
      'pointer-events': !_vm.target.isPaused && (_vm.active || _vm.target.mode == 'view') ? 'auto' : 'none'
    }
  }, [_vm.target.isOwner && _vm.target.blob.video.rec && !_vm.target.blob.video.src ? _c('div', {
    staticClass: "owner-controls absolute-fill d-flex flex-column"
  }, [_c('div', {
    staticClass: "flex-grow-1 d-flex justify-center align-center"
  }, [_vm.target.count ? _c('span', {
    staticClass: "red--text text-shadow-dark count-in"
  }, [_vm._v(_vm._s(_vm.target.count))]) : _vm._e()]), _c('div', {
    staticClass: "flex-grow-0"
  }, [_c('div', {
    staticClass: "d-flex justify-center mx-n3 mb-4"
  }, [_vm.target.isMediaRecorderSupported ? _c('media-source-menu', {
    ref: "media-source-menu",
    attrs: {
      "mirror": _vm.target.video.mirror,
      "scale": 1 / _vm.target.scale
    },
    on: {
      "change:media-source": function (v) {
        return _vm.target.mediaSource = v;
      },
      "change:mirror": function (v) {
        return _vm.target.video.mirror = v;
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var on = _ref.on;
        return [_c('v-btn', _vm._g({
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }],
          staticClass: "mx-3 interactive",
          attrs: {
            "fab": "",
            "x-large": "",
            "dark": "",
            "color": "secondary",
            "disabled": _vm.target.isRecording
          },
          on: {
            "mouseup": _vm.handleSelected,
            "touchend": _vm.handleSelected
          }
        }, on), [_c('v-icon', {
          attrs: {
            "large": ""
          }
        }, [_vm._v(_vm._s(_vm.mdiCog))])], 1)];
      }
    }], null, false, 2223123715)
  }) : _vm._e(), _vm.target.isMediaRecorderSupported ? _c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticClass: "mx-3 interactive",
    attrs: {
      "fab": "",
      "x-large": "",
      "dark": "",
      "color": "red",
      "loading": _vm.target.startCountdownStatus.pending,
      "disabled": _vm.target.startCountdownStatus.pending
    },
    on: {
      "click": function () {
        return _vm.target.isRecording ? _vm.target.stopRecording() : _vm.target.startCountdown();
      },
      "mouseup": _vm.handleSelected,
      "touchend": _vm.handleSelected
    }
  }, [_c('v-icon', {
    attrs: {
      "large": ""
    }
  }, [_vm._v(_vm._s(_vm.target.isRecording ? _vm.mdiStop : _vm.mdiRecord))])], 1) : _vm._e()], 1), _c('v-slider', {
    staticClass: "playback-slider interactive px-4",
    attrs: {
      "hide-details": "",
      "step": "0",
      "disabled": _vm.target.isRecording || !isFinite(_vm.target.duration) || !_vm.target.playbackIsLoaded,
      "value": _vm.target.playhead / _vm.target.duration * 100.0
    },
    on: {
      "input": _vm.target.seek,
      "start": function () {
        return _vm.target.pause();
      },
      "mousedown": function ($event) {
        $event.stopPropagation();
      },
      "click": function ($event) {
        $event.stopPropagation();
      }
    },
    nativeOn: {
      "touchstart": function ($event) {
        $event.stopPropagation();
      }
    }
  }), _c('div', {
    staticClass: "d-flex justify-center px-4 mb-2 font-weight-bold title"
  }, [_vm.target.video.src && !_vm.target.isRecording ? [_c('div', {
    staticClass: "white--text text-shadow-dark"
  }, [_vm._v(_vm._s(_vm._f("video-timestamp")(_vm.target.playhead)))]), _c('v-spacer')] : _vm._e(), _c('div', {
    staticClass: "white--text text-shadow-dark",
    domProps: {
      "innerHTML": _vm._s(_vm.target.count || !_vm.target.video.src && !_vm.target.isRecording ? '&nbsp;' : _vm.$options.filters['video-timestamp'](_vm.target.duration))
    }
  }), _vm.target.isRecording && !_vm.target.count && _vm.target.duration > 30 ? _c('div', {
    staticClass: "red--text text-shadow-dark ml-2"
  }, [_vm._v(" (60s limit) ")]) : _vm._e()], 2)], 1)]) : _c('div', {
    staticClass: "default-controls absolute-fill d-flex justify-center align-center",
    class: {
      active: _vm.active,
      'is-playing': !_vm.target.isPaused
    },
    on: {
      "click": function () {
        _vm.target.playPause();
        _vm.active = true;
      }
    }
  }, [_vm.target.error && !_vm.static ? _c('div', {
    staticClass: "d-flex flex-column align-center"
  }, [_c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticStyle: {
      "pointer-events": "auto"
    },
    attrs: {
      "fab": "",
      "x-large": "",
      "dark": "",
      "color": "warning",
      "loading": _vm.target.reloadStatus.pending
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.target.reload.apply(null, arguments);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiRefresh)
    }
  })], 1), _c('div', {
    staticClass: "mt-3 overline"
  }, [_vm._v("Processing video…")])], 1) : _c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticStyle: {
      "pointer-events": "auto"
    },
    attrs: {
      "fab": "",
      "x-large": "",
      "dark": "",
      "color": "primary",
      "disabled": !_vm.target.playbackIsLoaded
    },
    on: {
      "click": function ($event) {
        _vm.target.isPaused && _vm.$emit('play-video');
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.target.isPaused ? _vm.mdiPlay : _vm.mdiPause)
    }
  })], 1), _c('div', {
    staticClass: "playback-details"
  }, [_c('v-slider', {
    staticClass: "playback-slider px-4",
    attrs: {
      "hide-details": "",
      "step": "0",
      "disabled": !_vm.target.playbackIsLoaded,
      "value": _vm.target.playhead / _vm.target.duration * 100.0
    },
    on: {
      "input": _vm.target.seek,
      "start": _vm.target.pause,
      "click": function ($event) {
        $event.stopPropagation();
      },
      "mousedown": function ($event) {
        $event.stopPropagation();
      }
    },
    nativeOn: {
      "touchstart": function ($event) {
        $event.stopPropagation();
      }
    }
  }), _c('div', {
    staticClass: "d-flex px-4 mb-2 font-weight-bold title white--text text-shadow-dark"
  }, [_c('div', [_vm._v(_vm._s(_vm._f("video-timestamp")(_vm.target.playhead)))]), _c('v-spacer'), _c('div', [_vm._v(_vm._s(_vm._f("video-timestamp")(_vm.target.duration)))])], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }